import { render, staticRenderFns } from "./UrgencyProviders.vue?vue&type=template&id=fbaec2d8&scoped=true&lang=pug"
import script from "./UrgencyProviders.vue?vue&type=script&lang=js"
export * from "./UrgencyProviders.vue?vue&type=script&lang=js"
import style0 from "./UrgencyProviders.vue?vue&type=style&index=0&id=fbaec2d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbaec2d8",
  null
  
)

export default component.exports